import { timelineConnectorClasses, timelineContentClasses, timelineItemClasses } from '@mui/lab'
import { SxProps } from '@mui/material'

export interface TimelineStyles {
  timeLineWrapper: SxProps
  timeLineDot: SxProps
  timeLineConnector: SxProps
  timeLineContent: SxProps
}
export const timelineStyles: TimelineStyles = {
  timeLineWrapper: {
    pl: 0,
    py: 0,
    pr: 0,
    margin: 0,
    [`& .${timelineItemClasses.root}:before`]: {
      flex: 0,
      padding: 1,
    },

    [`.${timelineItemClasses.root}`]: {
      [`&:last-child .${timelineConnectorClasses.root}`]: {
        display: 'none',
      },
      [`&:first-of-type .${timelineContentClasses.root}`]: {
        pb: 5,
      },
    },
  },
  timeLineDot: { bgcolor: 'button.borderSecondary', m: 0, boxShadow: 'none' },
  timeLineConnector: { bgcolor: 'button.borderSecondary' },
  timeLineContent: { py: 0, display: 'flex', flexDirection: 'column', mt: -1 },
}
